import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
// import api from "../../api/api";

export const getTeachersThunk = createAsyncThunk("teachers/get", async () => {
  const response = await axios.get(
    "https://tatvagyan.in/thinkzone/getTeachers"
  );
  return response.data;
});

export const saveTeacherThunk = createAsyncThunk(
  "teachers/post",
  async (teacherData) => {
    const response = await axios.post(
      "https://tatvagyan.in/thinkzone/saveTeachers",
      teacherData
    );
    return response.data;
  }
);
